export default defineNuxtRouteMiddleware(async to => {
  if (import.meta.server) return

  const { $keycloak } = useNuxtApp()
  const { loggedUser, refetchProfile, logout } = useAuthStore()
  const { onLogin, getToken } = useApollo()

  let apolloToken = null
  try {
    apolloToken = await getToken()
  } catch (error) {
    console.error('Failed to get token from Apollo:', error)
    return navigateTo('/', { external: true })
  }

  if ($keycloak.authenticated) {
    const keycloakToken = $keycloak.token

    if (apolloToken !== keycloakToken) {
      try {
        await onLogin(keycloakToken)
      } catch (error) {
        console.error('Failed to synchronize Apollo token with Keycloak token:', error)
        await logout()
        return navigateTo('/', { external: true })
      }
    }

    if (!loggedUser) {
      try {
        const profile = await refetchProfile()

        if (profile) {
          if (['/register', '/register-verify', '/verify'].includes(to.path)) {
            return navigateTo('/', { external: true })
          }
          if (to.path.startsWith('/admin') && !profile.is_superadmin) {
            return navigateTo('/', { external: true })
          }
        } else {
          console.warn('Keycloak authenticated but no user profile could be fetched.')
          await $keycloak.logout()
          await logout()
          return navigateTo('/', { external: true })
        }
      } catch (error) {
        console.error('Failed to refetch user profile:', error)
        await logout()
        return navigateTo('/', { external: true })
      }
    }

    return
  }

  if (apolloToken) {
    try {
      await logout()
    } catch (error) {
      console.error('Error during logout:', error)
    }
  }

  if (to.path.startsWith('/admin')) {
    return navigateTo('/', { external: true })
  }

  return
})
